export class AppConstants {
	static actionType = {
		hrPendency: 'PENDÊNCIA RH',
	};

	static debounce = {
		/**
		 * Time in miliseconds
		 */
		time: 300,
	};

	static jwt = {
		/**
		 * Time in seconds
		 */
		intervalToRefreshToken: 60,
	};

	static organization = {
		/**
		 * Id - Sanus
		 */
		id: 'd8355112-8df4-4a38-b0bb-9157d2ff731a',
		name: 'Sanus',
	};

	static organizations = {
		/**
		 * O texto exibido para representar quando o filtro selecionado exibe dados de todas as organizações
		 */
		labelForAll: 'Todas',
	};

	static pagination = {
		itemsPerPage: 10,
	};

	static time = {
		miliseconds: 1000,
	};
}
